import { httpClient } from "@services/api/httpClient";

import { OfferApplicantStatus } from './../../../../types/OfferApplicantStatus.interface';

export async function submitOfferDecision(status: OfferApplicantStatus) {
  const response = await httpClient.post(`/offer-applicant/submit-offer-decision`, { decision: status });
  return response.data;
}